import {Component} from "react";
import {closeModal, refresh, validatePayment} from "../../helpers/Actions";


export default class Dialogs extends Component {
    render() {
        return (
            <div className="dialogs">
                <dialog id="table-not-found">
                    <div className="header warning">
                        Contraseña invalida
                    </div>
                    <div className="body">
                        La contraseña ingresada no tiene ninguna mesa asignada o ya no tiene lugares apartados.
                        <br/><br/>Por favor intentalo de nuevo.
                    </div>
                    <div className="footer">
                        <button className="default" onClick={closeModal}>Cerrar</button>
                    </div>
                </dialog>
                <dialog id="table-without-seats">
                    <div className="header warning">
                        Asientos insuficientes
                    </div>
                    <div className="body">
                        Durante tu compra, alguien mas ha comprado asientos en la misma mesa y ya no quedan suficientes lugares para finalizar tu compra.
                    </div>
                    <div className="footer">
                        <button className="default" onClick={closeModal}>Cerrar</button>
                        <button className="default" onClick={refresh}>Reintentar</button>

                    </div>
                </dialog>

                <dialog id="secure-dialog">
                    <div className="header warning">
                        Verificación requerida por el banco
                    </div>
                    <div className="body">
                        Tu banco solicitó una verificación de 2 pasos. <br/> Una vez concluida, espera <b>10 SEGUNDOS</b> y presiona el botón <b>Validar pago</b>
                    </div>
                    <div className="footer">
                        <button className="warning" onClick={validatePayment} >Validar pago</button>
                    </div>
                </dialog>

                <dialog id="sin-asientos">
                    <div className="header warning">
                        Mesa llena
                    </div>
                    <div className="body">
                        La mesa que seleccionaste no tiene asientos, por favor selecciona otra mesa con círculos verdes.
                    </div>
                    <div className="footer">
                        <button className="default" onClick={closeModal}>Cerrar</button>
                    </div>
                </dialog>
            </div>
        );
    }
}